import * as React from 'react';
import { st, classes } from './CoreDropdown.st.css';
import { CorePopover, } from '../CorePopover';
import { CoreDropdownContent } from '../CoreDropdownContent';
import { CLICK, HOVER } from './constants';
import { filterDataProps } from '../../utils/FilterDataProps';
import { KEYS } from '../../../../../common/keyCodes';
/**
 * Dropdown
 */
export class CoreDropdownComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.dropdownContentRef = null;
        this.state = { isOpen: false, selectedIds: [] };
        this.close = this.close.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onPopoverClick = this.onPopoverClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onOptionHover = this.onOptionHover.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this._onContentMouseDown = this._onContentMouseDown.bind(this);
    }
    componentDidMount() {
        this.initializeSelectedOptions();
    }
    componentDidUpdate(prevProps) {
        if (!CoreDropdownComponent.areSelectedIdsEqual(this.props.initialSelectedIds, prevProps.initialSelectedIds)) {
            this.initializeSelectedOptions();
        }
    }
    initializeSelectedOptions() {
        const { initialSelectedIds, options, onInitialSelectedOptionsSet } = this.props;
        const selectedOptions = (initialSelectedIds || [])
            .map((id) => options.find((option) => id === option.id))
            .filter((option) => option && !option.isDisabled && option.isSelectable);
        const selectedIds = selectedOptions.map((x) => x && x.id);
        this.setState({
            selectedIds: selectedIds,
        });
        onInitialSelectedOptionsSet && onInitialSelectedOptionsSet(selectedOptions);
    }
    handleClickOutside() {
        this.close();
    }
    _onExpandedChange() {
        if (this.props.onExpandedChange) {
            this.props.onExpandedChange(this.state.isOpen);
        }
    }
    open() {
        this.setState({ isOpen: true }, () => this._onExpandedChange());
    }
    onPopoverClick() {
        if (this.state.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }
    close() {
        if (this.state.isOpen) {
            this.setState({ isOpen: false }, this._onExpandedChange);
        }
    }
    getSelectedOption() {
        return this.dropdownContentRef
            ? this.dropdownContentRef.getSelectedOption()
            : null;
    }
    onKeyboardSelect() {
        const selectedOption = this.getSelectedOption();
        this.onOptionClick(selectedOption);
    }
    isClosingKey(key) {
        const { dropdownA11yFixes } = this.props;
        return (key === KEYS.Tab ||
            key === KEYS.Escape ||
            (!dropdownA11yFixes && key === KEYS.Enter));
    }
    onKeyDown(evt) {
        const eventKey = evt.key;
        const { dropdownA11yFixes } = this.props;
        if (this.state.isOpen) {
            const handleSelect = () => {
                this.onKeyboardSelect();
                !this.props.multi && this.close();
                if (this.getSelectedOption() !== null) {
                    evt.preventDefault();
                }
            };
            switch (eventKey) {
                case KEYS.Enter: {
                    handleSelect();
                    if (dropdownA11yFixes) {
                        evt.preventDefault();
                    }
                    break;
                }
                case KEYS.Spacebar: {
                    if (dropdownA11yFixes) {
                        handleSelect();
                        evt.preventDefault();
                    }
                    break;
                }
                case KEYS.Tab:
                case KEYS.Escape: {
                    this.close();
                    break;
                }
                case KEYS.ArrowUp: {
                    if (evt.altKey) {
                        this.close();
                    }
                    break;
                }
                default:
            }
        }
        else {
            if (this.isClosingKey(eventKey)) {
                return;
            }
            if (dropdownA11yFixes) {
                if (eventKey === KEYS.Enter ||
                    eventKey === KEYS.Spacebar ||
                    eventKey === KEYS.ArrowDown ||
                    eventKey === KEYS.ArrowUp ||
                    (eventKey.length === 1 && eventKey.match(/[a-zA-Z]/)) ||
                    eventKey === KEYS.Home ||
                    eventKey === KEYS.End) {
                    evt.preventDefault();
                }
                else {
                    return;
                }
            }
            this.open();
        }
        if (!this.props.preventContentKeydown) {
            this.dropdownContentRef &&
                this.dropdownContentRef.onKeyDown(eventKey, evt);
        }
    }
    _onContentMouseDown(e) {
        const { onContentMouseDown } = this.props;
        onContentMouseDown && onContentMouseDown(e);
    }
    onOptionHover(option) {
        if (this.props.onOptionHover) {
            this.props.onOptionHover(option);
        }
    }
    onOptionClick(option) {
        const { onSelect, onDeselect, multi, allowReselect } = this.props;
        const { selectedIds } = this.state;
        const newState = {
            isOpen: !!multi,
            selectedIds,
        };
        let callback = onSelect;
        if (multi) {
            // Multi select
            if (option) {
                // if option was clicked (could be null when Autocomplete receives a new string)
                if (selectedIds.includes(option.id)) {
                    // if clicked a selected option, unselect it
                    newState.selectedIds = selectedIds.filter((x) => x !== option.id);
                    callback = onDeselect;
                }
                else {
                    // if clicked a new option, add it to selection
                    newState.selectedIds = [...selectedIds, option.id];
                }
            }
            // Single select
        }
        else if (option) {
            // if option was clicked (could be null when Autocomplete receives a new string)
            if (selectedIds.includes(option.id)) {
                this.close();
                if (!allowReselect) {
                    // if clicked on the selected item, exit and do nothing
                    return;
                }
            }
            else {
                // if clicked on a new option, make it the selected
                newState.selectedIds = [option.id];
            }
        }
        else {
            // if non existing option selected, unselect existing ones
            newState.selectedIds = [];
        }
        this.setState(newState, () => callback(option));
    }
    render() {
        const { openTrigger, placement, options, children, showArrow, fixedFooter, fixedHeader, disabled, timeout, forceContentElementVisibility, style: inlineStyles, id, flip, fixed, moveBy, readOnly, role, contentId, optionsContainerZIndex, dynamicWidth, appendTo, className, contentClassName, contentRole, contentActiveDescendant, } = this.props;
        const { isOpen, selectedIds } = this.state;
        const hasContent = Boolean((options && options.length) || fixedHeader || fixedFooter);
        const shown = forceContentElementVisibility ||
            (isOpen && !disabled && !readOnly && hasContent);
        return (React.createElement(CorePopover, { className: st(classes.root, { 'content-visible': shown }, className), contentClassName: contentClassName, placement: placement, shown: shown, showArrow: showArrow, timeout: timeout, onClickOutside: this.handleClickOutside, onClick: !disabled && !readOnly && openTrigger === CLICK
                ? () => this.onPopoverClick()
                : undefined, onMouseEnter: !disabled && !readOnly && openTrigger === HOVER
                ? () => this.open()
                : undefined, onKeyDown: !disabled && !readOnly ? this.onKeyDown : undefined, onMouseLeave: !disabled && !readOnly && openTrigger === HOVER
                ? this.close
                : undefined, style: inlineStyles, id: id, flip: flip, fixed: fixed, moveBy: moveBy, role: role, zIndex: optionsContainerZIndex, dynamicWidth: dynamicWidth, appendTo: appendTo, ...filterDataProps(this.props) },
            React.createElement(CorePopover.Element, null, children),
            React.createElement(CorePopover.Content, null,
                React.createElement(CoreDropdownContent, { className: classes.dropdownContent, "data-hook": "dropdown-content", ref: (dropdownContent) => (this.dropdownContentRef = dropdownContent), contentRole: contentRole, options: options, fixedFooter: fixedFooter, fixedHeader: fixedHeader, selectedIds: selectedIds, onOptionClick: this.onOptionClick, onOptionHover: this.onOptionHover, onMouseDown: this._onContentMouseDown, optionsContainerId: contentId, contentActiveDescendant: contentActiveDescendant }))));
    }
}
CoreDropdownComponent.displayName = 'CoreDropdown';
CoreDropdownComponent.areSelectedIdsEqual = (selectedIds1, selectedIds2) => {
    if ((selectedIds1 === undefined && selectedIds2 === undefined) ||
        (selectedIds1 === null && selectedIds2 === null)) {
        return true;
    }
    return (Array.isArray(selectedIds1) &&
        Array.isArray(selectedIds2) &&
        selectedIds1.length === selectedIds2.length &&
        selectedIds1.every((item, index) => item === selectedIds2[index]));
};
export const CoreDropdown = CoreDropdownComponent;
//# sourceMappingURL=CoreDropdown.js.map